import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Navigate } from 'react-router-dom'

import { Button, Col, Form, Input, Row, Typography } from 'antd'
import { BsPerson } from 'react-icons/bs'
import swal from 'sweetalert'

import SignupPageImg from '../assets/SignupPage.jpg'
import { vendorLogin } from '../redux'

export default function Login() {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()

  const onFinish = async (values) => {
    try {
      let { email, password } = values
      setLoading(true)
      await dispatch(vendorLogin(email, password, history))
      setLoading(false)
    } catch (error) {
      swal('', 'Server Error!', 'error')
      setLoading(false)
    }
  }
  if (localStorage.getItem('token')) {
    return <Navigate to='/' />
  } else {
    return (
      <>
        <section
          className='login-2-main'
          style={{
            backgroundImage: `url(${SignupPageImg})`,
            backgroundRepeat: 'no-repeat',
            // backgroundPosition: 'center',
            backgroundSize: 'cover',
          }}
        >
          <div className='inner-wrapper'>
            <Row align='middle' justify='center'>
              <Col md={12}>
                <div className='login_text_div'>
                  <div>
                    <h1 style={{ margin: 0 }}>Data-Driven</h1>
                    <h1 style={{ margin: 0, transform: 'translateY(-15px)' }}>Growth Engine</h1>
                    <p style={{ transform: 'translateY(-15px)' }}>
                      Maximize Sales, Marketing,
                      <br /> and Personalization Insights
                    </p>
                  </div>
                </div>
              </Col>
              <Col md={12}>
                <div className='right'>
                  <div className='signin-main'>
                    <div className='signin'>
                      <Form
                        name='login'
                        className='login-form'
                        layout='vertical'
                        onFinish={onFinish}
                      >
                        <h2>Login</h2>
                        <Form.Item
                          name='email'
                          label='Username'
                          rules={[{ required: true, message: 'Username is Required' }]}
                          requiredMark={'optional'}
                        >
                          <Input
                            bordered={false}
                            autoComplete='off'
                            placeholder='Enter Username...'
                            suffix={<BsPerson />}
                          />
                        </Form.Item>
                        <Form.Item
                          name='password'
                          label='Password'
                          rules={[{ required: true, message: 'Password is Required' }]}
                          requiredMark={'optional'}
                        >
                          <Input.Password
                            bordered={false}
                            type='password'
                            placeholder='Password...'
                          />
                        </Form.Item>

                        <Form.Item className='btn_container'>
                          <Button
                            loading={loading}
                            type='primary'
                            htmlType='submit'
                            className='login'
                          >
                            Login
                          </Button>
                        </Form.Item>
                      </Form>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <footer className='footer'>
              <div className='inner-wrapper'>
                <Typography.Text className='color-grey'>
                  Hanker Technologies Private Limited
                </Typography.Text>
                <Typography.Text className='color-grey'>© all rights reserved</Typography.Text>
              </div>
            </footer>
          </div>
        </section>
      </>
    )
  }
}
